import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { CuentasJardinModel, CuentasModel, ResponseCuentasJardinPaginationModel, ResponseOtrasCuentasModel } from 'src/app/model/Cuentas.model';
import { CuentasJardinCronogramaModel, ResponseCuentasJardinCronogramaPaginationModel } from 'src/app/model/JardinCronograma.model';
import { apiService } from 'src/app/service/api.service';
import { environment } from 'src/environments/environment';
import { ModalFichaCuentaComponent } from '../../../dialogs/modal-ficha-cuenta/modal-ficha-cuenta.component';

@Component({
  selector: 'app-inicio-cronograma',
  templateUrl: './inicio-cronograma.component.html',
  styleUrls: ['./inicio-cronograma.component.css']
})
export class InicioCronogramaComponent implements OnInit {

  displayedColumns=[];
  filterValues = {};
  filterSelectObj = [];
  tipoCampos = [];
  dataSource: MatTableDataSource<CuentasJardinCronogramaModel>;

  pageEvent: PageEvent;
  pageIndex:number;
  length:number;

  palabraClave: string;
  idRegion:number;
  idComuna:number;
  idPrograma:number;
  arrayComunas = [];
  apiEndpoint = environment.apiEndpoint;
  getSelect = false;
  columnNames = [
    { id: 'region', value: 'region' }, 
    { id: 'comuna', value: 'comuna' }, 
    { id: 'programa', value: 'programa' }, 
    { id: 'codigo', value: 'codigo' }, 
    { id: 'nombre', value: 'nombre' }, 
    { id: 'fechaCapacitacion', value: 'fechaCapacitacion' }, 
    { id: 'fechaInicioAutoevaluacion', value: 'fechaInicioAutoevaluacion' }, 
  ];
  @ViewChild(MatPaginator, {read: true}) paginator: MatPaginator;
  @Input() infoSelectJardin: CuentasModel;
  constructor(
    private api: apiService,    
    public dialog: MatDialog,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.palabraClave = "";
    this.idRegion = 0;
    this.idComuna = 0;
    this.idPrograma = 0;
    this.getServerData(); 
  }

  
  public getServerData(event?:PageEvent){
    this.callData(event != null ? event : null );
  }


  public callData(event?:PageEvent){
    let pageNum = event != null ? (event.pageIndex + 1) : 1;
    let pageSize = event != null ? event.pageSize : 10;
    this.spinner.show();
    this.api.API_POST_getCuentasJardinCronograma(pageNum,pageSize,this.palabraClave,this.idRegion,this.idComuna,this.idPrograma).subscribe((response: ResponseCuentasJardinCronogramaPaginationModel) => {
      this.displayedColumns = this.columnNames.map(x => x.id);
      this.dataSource = new MatTableDataSource<CuentasJardinCronogramaModel>(response.payload.list);
      this.pageIndex = (response.payload.pageNum - 1);
      this.length = response.payload.total;

      setTimeout(() => {
        this.dataSource.paginator = this.paginator;
        this.spinner.hide();
      }, 1000);
        
    },
    (err) => {
      console.log("error"+err)
    })
  }

  buscar(palabraClave){
    this.palabraClave = palabraClave;
    this.callData(null);
  }
  

  seleccionarRegion(value){
    this.idRegion = value;
    const indexRegion =this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(value);
    this.arrayComunas = this.infoSelectJardin.regiones[indexRegion].comunas;
    this.callData(null);
  }

  seleccionarComuna(value){
    this.idComuna = value;
    this.callData(null);
  }

  seleccionarPrograma(value){
    this.idPrograma = value;
    this.callData(null);
  }


  nombreRegion(id){
    const indexRegion =this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(id);
    return this.infoSelectJardin.regiones[indexRegion].nombre;
  }

  nombreComuna(idRegion,IdComuna){
    const indexRegion = this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(idRegion);
    const indexComuna = this.infoSelectJardin.regiones[indexRegion].comunas.map(element => element.idComuna).indexOf(IdComuna);
    return this.infoSelectJardin.regiones[indexRegion].comunas[indexComuna].nombre;
  }




}
